export default __webpack_public_path__ + "static/media/FlyingFrog27.6f3d495b.png";